import Cookies from 'js-cookie';
import {
  EMPLOYEE_STAFF_ON_CLICK_EXPORT,
  EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF,
  EMPLOYEE_STAFF_ON_CHANGE_KEYWORD,
  EMPLOYEE_STAFF_LIST_STAFF_REQUEST,
  EMPLOYEE_STAFF_LIST_ROLES_REQUEST,
  EMPLOYEE_STAFF_PAGE_REQUEST,
  SUBMITTING_GET_EMPLOYEES,
  SUBMITTING_CREATE_EMPLOYEE,
  SUBMITTING_UPDATE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_CANCEL,
  EMPLOYEE_STAFF_ON_CLICK_ROW,
  EMPLOYEE_STAFF_LIST_OUTLET_REQUEST,
  EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_SUBMIT_FORM,
  EMPLOYEE_STAFF_RESEND_INVITATION,
  EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA,
  EMPLOYEE_STAFF_ON_CANCEL_RESEND,
  EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST,
  EMPLOYEE_STAFF_ACTIVE_STAFF_LIST_REQUEST,
  EMPLOYEE_STAFF_ON_CHANGE_STATUS,
  EMPLOYEE_STAFF_ON_CLICK_ADD_STAFF_SLOT,
  EMPLOYEE_STAFF_GET_FEATURE_PRICE,
  EMPLOYEE_STAFF_VERIFY_ADD_STAFF_SLOT,
  EMPLOYEE_STAFF_ON_DEACTIVATE_STAFF,
  EMPLOYEE_STAFF_ON_CLICK_REACTIVATE_BUTTON,
  EMPLOYEE_STAFF_ASSIGN_EMPLOYEE_TO_SLOT,
  EMPLOYEE_STAFF_ON_CLICK_PAY_TO_REACTIVATE,
  EMPLOYEE_STAFF_STOP_RENEWAL_SLOT,
  EMPLOYEE_STAFF_ON_CLICK_LINK_STOP_RENEWAL,
  EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE,
} from 'actions/employees/staff/constants';
import {
  openRightColumn,
  closeRightColumn,
  setEmployeeDetail,
  setEmployees,
  listStaffRequest,
  listOutletRequest,
  listRolesRequest,
  setSubmitting,
  setOutlets,
  setRoles,
  showAssignOutletModal,
  hideAssignOutletModal,
  showEmployeeDeleteModal,
  hideEmployeeDeleteModal,
  setResendCaptchaEmail,
  showResendCaptchaModal,
  hideResendCaptchaModal,
  resendInvitation,
  setCanAccessRole,
  listPermissionRequest,
  showPinRequiredModal,
  setPinRequiredModal,
  activeStaffListRequest,
  showPurchaseStaffSlotModal,
  hidePurchaseStaffSlotModal,
  setStaffFeaturePrice,
  getStaffFeaturePrice,
  setSlotDetail,
  hideDeactivateStaffModal,
  showReactivateStaffModal,
  setAvailableSlots,
  showReactivateStaffNoSlotModal,
  hideReactivateStaffModal,
  setAssignedEmployee,
  verifyAddStaffSlot,
  setPendingBilling,
  hideStopRenewalModal,
  showStopRenewalModal,
  hideReactivateStaffNoSlotModal,
  showPaymentGatewayErrorModal,
  showDeactivateEmployeeErrorMessage,
} from 'actions/employees/staff';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as actNotif from 'actions/notifications';
import { showProgressBar, hideProgressBar, setProfile } from 'actions';
import { initialize, reset, change } from 'redux-form';
import * as apiOutlets from 'api/outlets';
import * as apiRoles from 'api/roles';
import * as apiEmployees from 'api/employees';
import * as apiProfile from 'api/profile';
import sort from 'lodash/sortBy';
import * as clevertapEmployeesStaff from 'clevertap/employees/staff';
import moment from 'moment';
import download from 'downloadjs';
import { getFeaturePrice } from 'api/feature/getFeaturePrice';
import * as apiBilling from 'api/billing';
import { showBillingNotification } from 'actions/billingNotification/billingNotification';
import _ from 'lodash';
import {
  setNotificationMessage,
  setNotificationType,
} from 'actions/billingRedirect';
import * as apiUploadImage from 'api/s3';
import { setFile } from 'actions/uploadImage';
import { USER } from 'utils/uploadS3Constants';
import isFeatureEnabled from 'selectors/isFeatureEnabled';
import { phoneNumberFormatter } from 'utils/formatter';
import { constructFormData } from '../../utils/s3Util';

const MAX_RESEND_QUOTA = 2;

export function getQuotaExpiredDate() {
  return moment()
    .add(1, 'd')
    .toDate();
}

function quotaCookieKey({ email }) {
  return `__rsd_email_quota_${email}`;
}

export function getQuota({ email }) {
  const key = quotaCookieKey({ email });
  const quota = Cookies.get(key);
  const expires = getQuotaExpiredDate();
  if (quota === undefined) {
    Cookies.set(key, MAX_RESEND_QUOTA, { expires });
    return MAX_RESEND_QUOTA;
  }
  return parseInt(quota);
}

export function decrementQuota({ email }) {
  const key = quotaCookieKey({ email });
  const value = Cookies.get(key);
  const quota = parseInt(value) || 0;
  const expires = getQuotaExpiredDate();
  if (quota > 0) {
    Cookies.set(key, quota - 1, { expires });
  } else {
    Cookies.set(key, 0, { expires });
  }
}

export function* onChangeKeywordFlow(request) {
  const { payload } = request;
  // debounce user input
  yield call(delay, 300);
  yield put(closeRightColumn());
  yield put(reset('staff'));
  yield put(setEmployeeDetail({ employee: null }));
  if (payload.active) {
    yield put(activeStaffListRequest({ ...payload, submitFlag: true }));
  } else {
    yield put(listStaffRequest({ ...payload, submitFlag: true }));
  }
}

export function* onChangeStatusFlow(request) {
  const {
    payload: { keyword, status, user, occupied },
  } = request;
  yield put(closeRightColumn());
  yield put(reset('staff'));
  yield put(setEmployeeDetail({ employee: null }));
  if (status !== 'active') {
    yield put(
      listStaffRequest({ active: false, keyword, user, submitFlag: true })
    );
    // get all the slots that are valid and not occupied by any user
    const res = yield call(apiEmployees.getActiveEmployees, {
      params: { active: true, occupied: false },
    });
    if (res.data) {
      const sortedFreeSlots = sort(res.data, d =>
        d.status === 'Free' ? [`${d.outletId}`] : [`${d.createdAt}`]
      );
      const sortedSlots = sort(sortedFreeSlots, d => [
        `${d.status}`.toLowerCase(),
      ]);
      yield put(setAvailableSlots(sortedSlots));
    }
  } else {
    yield put(
      activeStaffListRequest({
        active: true,
        keyword,
        user,
        occupied,
        submitFlag: true,
      })
    );
  }
}

export function* resendInvitationFlow(request) {
  const {
    payload: { email },
  } = request;
  try {
    yield call(decrementQuota, { email });
    yield put(showProgressBar());
    yield call(
      apiEmployees.resendInvitation,
      { pending_employee_email: email },
      {}
    );
    // Please git blame api.js at line 2681 on moka-rails to see why this message is hard-coded
    yield put(actNotif.success('Employee invitation sent!'));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
}

export function* onClickExportFlow(request) {
  const { employees, user, status } = request.payload;
  try {
    yield put(showProgressBar());
    let data =
      'First Name,Last Name,Role,Email,Email Status,Phone,Outlet,Status';
    employees.forEach(e => {
      if (data) {
        data = `${data}\n`;
      }

      const outlets = e.outlets === undefined ? [] : e.outlets;
      const phone = e.phone ? `0${e.phone}` : ``;
      const emailConfirmed = e.is_email_confirmed
        ? 'Verified'
        : 'Waiting for Verification';
      data = `${data}${e.first_name},${e.last_name},${e.role.name},${e.email},${emailConfirmed},${phone},"`;
      for (let i = 0; i < outlets.length; i++) {
        const o = outlets[i];
        if (i > 0) {
          data = `${data}, ${o.name}`;
        } else {
          data = `${data}${o.name}`;
        }
      }
      data = `${data}",${status}`;
    });
    download(data, `Export-Employee-${user.business.name}.csv`);
    // let data = []
    // const response = yield call(apiEmployees.getExportEmployeesServiceV1,{})
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
}

export function* onClickInviteStaffFlow(request) {
  const {
    payload: { slot },
  } = request;
  yield put(setSlotDetail(slot));
  yield put(setEmployeeDetail({ employee: null }));
  yield put(
    initialize('staff', {
      email: '',
      first_name: '',
      last_name: '',
      photo_url: '',
      description: '',
      outlets: [],
      phone: '',
    })
  );
  yield put(openRightColumn());
}

export function* listStaffRequestFlow(request) {
  const {
    payload: { active, keyword, submitFlag, user },
  } = request;
  try {
    yield put(showProgressBar());
    if (submitFlag) {
      yield put(setSubmitting({ submitting: SUBMITTING_GET_EMPLOYEES }));
    }
    yield put(setEmployees({ employees: [] }));

    const response = yield call(apiEmployees.getEmployeesServiceV1, {
      params: { active, deep: true, keyword, include_me: user.is_manager },
    });
    // prevent NULL from server, encapsulate it first
    yield put(
      setEmployees({
        employees: sort(response.data.employees, d => [
          `${d.first_name}`.toLowerCase(),
          `${d.last_name}`.toLowerCase(),
        ]),
      })
    );
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    if (submitFlag) {
      yield put(setSubmitting({ submitting: null }));
    }
    yield put(hideProgressBar());
  }
}

export function* listActiveStaffRequestFlow(request) {
  const {
    payload: { keyword, submitFlag, user, active, occupied },
  } = request;
  try {
    yield put(showProgressBar());
    if (submitFlag) {
      yield put(setSubmitting({ submitting: SUBMITTING_GET_EMPLOYEES }));
    }
    yield put(setEmployees({ employees: [] }));
    const response = yield call(apiEmployees.getActiveEmployees, {
      params: { occupied, active, keyword, includeMe: user.is_manager },
    });
    // free slots should be sorted by outletId
    const sortedFreeSlots = sort(response.data, d =>
      d.status === 'Free' ? [`${d.outletId}`] : [`${d.createdAt}`]
    );
    const sortedEmployees = sort(sortedFreeSlots, d => [
      `${d.status}`.toLowerCase(),
    ]);
    yield put(setEmployees({ employees: sortedEmployees }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    if (submitFlag) {
      yield put(setSubmitting({ submitting: null }));
    }
    yield put(hideProgressBar());
  }
}

export function* listOutletRequestFlow() {
  try {
    yield put(showProgressBar());
    const response = yield call(apiOutlets.outlets);
    const outlets = response.data;
    yield put(setOutlets({ outlets }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
}

export function* listRolesRequestFlow() {
  try {
    yield put(showProgressBar());
    const pinAccessImprovement = yield select(
      isFeatureEnabled,
      'pin-access-improvement'
    );

    const response = yield call(apiRoles.getRolesV1, {
      params: { deep: pinAccessImprovement },
    });
    const roles = response.data.roles.map(r => {
      let response = {
        id: r.id,
        name: r.name,
      };
      if (pinAccessImprovement) {
        response = { ...response, level: r.level, permissions: r.permissions };
      }
      return response;
    });
    yield put(setRoles({ roles: sort(roles, 'name') }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
}

export function* listPermissionRequestFlow(request) {
  const {
    payload: { userId },
  } = request;
  try {
    yield put(showProgressBar());
    const response = yield call(apiEmployees.getPermission, {
      userId,
      params: {},
    });
    let canAccessRole = false;
    response.data.permissions.forEach(p => {
      canAccessRole =
        canAccessRole ||
        (p.access === 'Back-office' &&
          p.menu === 'Employees' &&
          p.sub_menu === 'Role');
    });
    yield put(setCanAccessRole({ canAccessRole }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
}

export function* pageRequestFlow(request) {
  const {
    payload: { user, status, billingNotification },
  } = request;
  yield put(initialize('search', { status: 'active' }));
  yield put(closeRightColumn());
  yield put(hidePurchaseStaffSlotModal());
  yield put(setEmployees({ employees: [] }));
  yield put(setEmployeeDetail({ employee: null }));
  yield put(showBillingNotification(billingNotification));
  yield put(setNotificationType(null));
  yield put(setNotificationMessage(null));
  yield put(setSlotDetail(null));
  yield put(hideReactivateStaffNoSlotModal());

  // need to call api profile to get updated user profile.
  // example for this case, need updated value of outlet_slot from internal tools.
  const resProfile = yield call(apiProfile.getProfile);
  yield put(setProfile(resProfile.data));

  // since we want to show loading spinner until ALL request are called
  // we cannot use `put` action since it is async
  // instead we call saga effects directly with no submit flag
  // and we set submit flag manually here
  yield put(setSubmitting({ submitting: 'page' }));
  yield call(listOutletRequestFlow, listOutletRequest());
  yield call(listRolesRequestFlow, listRolesRequest());
  if (status !== 'active') {
    yield call(
      listStaffRequestFlow,
      listStaffRequest({ active: false, keyword: '', user, submitFlag: false })
    );
  } else {
    yield call(
      listActiveStaffRequestFlow,
      activeStaffListRequest({
        active: true,
        keyword: '',
        user,
        submitFlag: false,
      })
    );
  }
  yield put(getStaffFeaturePrice());
  yield call(
    listPermissionRequestFlow,
    listPermissionRequest({ userId: user.id })
  );
  yield put(setSubmitting({ submitting: null }));
}

export function* onClickRowFlow(request) {
  const {
    payload: { employee, status },
  } = request;
  let staff = {};
  const pinAccessImprovement = yield select(
    isFeatureEnabled,
    'pin-access-improvement'
  );

  if (status === 'active') {
    const slot = employee;
    if (slot.employee) {
      staff = slot.employee;
      yield put(setEmployeeDetail({ employee: slot.employee }));
    }
    yield put(setSlotDetail(slot));
  } else {
    staff = employee;
    yield put(setEmployeeDetail({ employee: staff }));
    yield put(setSlotDetail(null));
  }

  yield put(
    initialize('staff', {
      id: staff.id || '',
      description: staff.description || '',
      email: staff.email || '',
      first_name: staff.first_name || '',
      last_name: staff.last_name || '',
      outlets: staff.outlets ? staff.outlets.map(o => `${o.id}`) : [],
      phone: phoneNumberFormatter(staff.phone) || '',
      photo_url: staff.photo_url || '',
      pin: staff.pin || '',
      assign_pin: !!staff.pin,
      role_id: `${staff.role.id}`,
      is_enable_in_app_permission: pinAccessImprovement
        ? staff.is_enable_in_app_permission
        : false,
    })
  );
  yield put(setFile(null));
  yield put(openRightColumn());
}

export function* onClickCancelFlow() {
  yield put(closeRightColumn());
  yield put(setEmployeeDetail({ employee: null }));
}

export function* onClickAssignOutletFlow() {
  yield put(showAssignOutletModal());
}

export function* onConfirmAssignOutletFlow(request) {
  const {
    payload: { assignedOutletIds },
  } = request;
  yield put(change('staff', 'outlets', assignedOutletIds));
  yield put(hideAssignOutletModal());
}

export function* onCancelAssignOutletFlow() {
  yield put(hideAssignOutletModal());
}

export function* onSubmitFormFlow(request) {
  const {
    payload: { values, previousEmployees, outlets, role, slotDetail, image },
  } = request;

  const pinAccessImprovement = yield select(
    isFeatureEnabled,
    'pin-access-improvement'
  );

  if (values.id) {
    clevertapEmployeesStaff.editStaff({ employee: values, outlets, role });
    yield put(setSubmitting({ submitting: SUBMITTING_UPDATE_EMPLOYEE }));
  } else {
    clevertapEmployeesStaff.inviteStaff({ employee: values, outlets, role });
    yield put(setSubmitting({ submitting: SUBMITTING_CREATE_EMPLOYEE }));
  }
  if (!values.outlets || values.outlets.length === 0) {
    yield put(showAssignOutletModal());
  } else if (values.assign_pin && !values.pin) {
    yield put(actNotif.error('Please make sure the PIN has been filled'));
  } else if (!values.role_id) {
    yield put(actNotif.error('Role is required for each of the employee'));
  } else {
    const data = {
      email: values.email,
      first_name: values.first_name,
      last_name: values.last_name,
      phone: values.phone,
      role_id: values.role_id,
      description: values.description,
      photo_url: values.photo_url,
      outlets: values.outlets,
      slot_id: slotDetail.id,
    };
    if (values.assign_pin) {
      data.auth_code = values.pin;
      if (pinAccessImprovement) {
        data.is_enable_in_app_permission = values.is_enable_in_app_permission;
      }
    } else {
      data.auth_code = '';
      values.pin = '';
    }
    let shouldSendEmail = false;
    let successMessage = '';
    try {
      yield put(showProgressBar());
      let employeeDetail = {};
      const employees = [];
      const activeEmployee = {
        id: slotDetail.id,
        businessId: slotDetail.businessId,
        outletId: slotDetail.outletId,
        status: slotDetail.status,
        createdAt: slotDetail.createdAt,
        expireDate: slotDetail.expireDate,
        employee: employeeDetail,
      };
      // map outlet
      const assignedOutletIds = {};
      values.outlets.forEach(oid => {
        assignedOutletIds[oid] = true;
      });
      const assignedOutlets = outlets.filter(outlet => {
        return assignedOutletIds.hasOwnProperty(outlet.id);
      });

      if (values.id) {
        // upload image
        if (image) {
          const formData = constructFormData(image, USER, values.id);
          const resUpload = yield call(
            apiUploadImage.postNewImage,
            formData,
            {}
          );
          data.photo_url = resUpload.data.download_image_url;
          values.photo_url = data.photo_url;
        }

        yield call(apiEmployees.putEmployeesServiceV1, {
          data,
          params: {},
          id: values.id,
        });

        previousEmployees.forEach(pe => {
          if (pe.employee && pe.employee.id === values.id) {
            employeeDetail = {
              ...pe.employee,
              email: values.email,
              first_name: values.first_name,
              last_name: values.last_name,
              phone: values.phone,
              role: {
                id: values.role_id,
                name: role.name,
              },
              description: values.description,
              photo_url: values.photo_url,
              outlets: assignedOutlets,
              pin: values.pin,
              is_enable_in_app_permission: pinAccessImprovement
                ? values.is_enable_in_app_permission
                : false,
            };
            if (
              pe.employee.email !== values.email &&
              !pe.employee.is_email_confirmed
            ) {
              shouldSendEmail = true;
            }
            activeEmployee.employee = employeeDetail;
            employees.push(activeEmployee);
          } else {
            employees.push(pe);
          }
        });
        successMessage = 'Employee was successfully saved';
      } else {
        const response = yield call(apiEmployees.postEmployeesServiceV1, {
          data,
          params: {},
        });

        // upload image
        let imageUrl = '';
        if (image) {
          const formData = constructFormData(
            image,
            USER,
            response.data.user_id
          );
          const resUpload = yield call(
            apiUploadImage.postNewImage,
            formData,
            {}
          );
          imageUrl = resUpload.data.download_image_url;
        }

        employeeDetail = {
          ...values,
          id: response.data.user_id,
          outlets: assignedOutlets,
          role: {
            id: role.id,
            name: role.name,
          },
          photo_url: imageUrl,
        };

        if (values.assign_pin) {
          employeeDetail.pin = values.pin;
          employeeDetail.is_enable_in_app_permission = pinAccessImprovement
            ? values.is_enable_in_app_permission
            : false;
        } else {
          employeeDetail.pin = '';
          employeeDetail.is_enable_in_app_permission = false;
        }

        previousEmployees.forEach(prev => {
          if (prev.id === activeEmployee.id) {
            prev.employee = employeeDetail;
          }
          employees.push(prev);
        });
        shouldSendEmail = true;
        successMessage = 'Employee invitation sent!';
      }
      if (shouldSendEmail) {
        yield call(
          apiEmployees.resendInvitation,
          { pending_employee_email: values.email },
          {}
        );
      }
      yield put(setFile(null));
      yield put(setEmployees({ employees }));
      yield put(setEmployeeDetail({ employee: employeeDetail }));
      yield put(initialize('staff', { ...values, id: employeeDetail.id }));
      yield put(actNotif.success(successMessage));
    } catch (error) {
      if (error.data && error.data.error && error.data.error.code === 8) {
        yield put(
          setPinRequiredModal({ message: error.data.error.user_message })
        );
        yield put(showPinRequiredModal());
      } else {
        yield put(actNotif.error(error.message));
      }
    } finally {
      yield put(hideProgressBar());
    }
  }
  yield put(setSubmitting({ submitting: null }));
}

export function* onCancelDeleteEmployeeFlow() {
  yield put(hideEmployeeDeleteModal());
}

export function* onConfirmDeleteEmployeeFlow(request) {
  const {
    payload: { employee, previousEmployees },
  } = request;
  clevertapEmployeesStaff.deleteStaff({ employee });
  try {
    yield put(showProgressBar());
    yield call(apiEmployees.deleteEmployeeServiceV1, {
      params: {},
      id: employee.id,
    });
    const employees = [];
    previousEmployees.forEach(e => {
      if (e.id !== employee.id) {
        employees.push(e);
      }
    });
    yield put(setEmployees({ employees }));
    yield put(setEmployeeDetail({ employee: null }));
    yield put(closeRightColumn());
    yield put(actNotif.success('Employee was successfully deleted'));
  } catch (error) {
    if (error.data && error.data.error && error.data.error.code === 8) {
      yield put(
        setPinRequiredModal({ message: error.data.error.user_message })
      );
      yield put(showPinRequiredModal());
    } else {
      yield put(actNotif.error(error.message));
    }
  } finally {
    yield put(hideProgressBar());
  }
  yield put(hideEmployeeDeleteModal());
}

export function* onClickDeleteEmployeeFlow() {
  yield put(showEmployeeDeleteModal());
}

export function* onClickResendInvitationFlow(request) {
  const {
    payload: { email },
  } = request;
  const quota = yield call(getQuota, { email });
  if (quota) {
    yield put(resendInvitation({ email }));
  } else {
    yield put(setResendCaptchaEmail({ email }));
    yield put(showResendCaptchaModal());
  }
}

export function* onCancelResendFlow() {
  yield put(setResendCaptchaEmail({ email: null }));
  yield put(hideResendCaptchaModal());
}

export function* onClickResendWithValidCaptchaFlow(request) {
  const {
    payload: { email },
  } = request;
  yield put(hideResendCaptchaModal());
  yield put(resendInvitation({ email }));
  yield put(setResendCaptchaEmail({ email: null }));
}

export function* onClickAddSlotFlow() {
  clevertapEmployeesStaff.clickAddStaffSlot();
  const { data } = yield call(apiBilling.getBillings);
  const pendingBilling = _.find(data, ['status', 'pending']);
  yield put(setPendingBilling(pendingBilling));
  yield put(showPurchaseStaffSlotModal());
  yield put(initialize('PurchaseStaffSlotForm', { slotNumber: 1 }));
}

export function* getStaffFeaturePriceFlow() {
  const response = yield call(getFeaturePrice, {
    feature_name: 'Slot Employee',
  });
  yield put(setStaffFeaturePrice(response.data));
}

export function* verifyAddSlotsFlow(request) {
  const { billingData } = request.payload;
  let response = {};

  try {
    response = yield call(apiBilling.verifyBilling, billingData);
    if (response.data) {
      window.location.replace(response.data.data.redirect_url);
    }
  } catch (error) {
    if (!error.data || error.data === ' ' || error.status >= 500) {
      yield put(showPaymentGatewayErrorModal());
    } else {
      yield put(actNotif.error(error.data.message));
    }
  } finally {
    yield put(hidePurchaseStaffSlotModal());
    yield put(hideReactivateStaffNoSlotModal());
  }
}

export function* deactivateStaffFlow(request) {
  const {
    payload: { slot, previousEmployees },
  } = request;
  try {
    yield put(showProgressBar());
    const bodyRequest = {
      assignedEmployeeId: null,
    };
    yield call(apiEmployees.putSlotEmployeeV1, {
      data: bodyRequest,
      params: {},
      slotId: slot.id,
    });
    const activeEmployees = [];
    previousEmployees &&
      previousEmployees.length > 0 &&
      previousEmployees.forEach(activeStaff => {
        if (activeStaff.id === slot.id) {
          activeStaff.employee = null;
        }
        activeEmployees.push(activeStaff);
      });
    yield put(setEmployees({ employees: activeEmployees }));
    yield put(setEmployeeDetail({ employee: null }));
    yield put(closeRightColumn());
    yield put(actNotif.success('Employee was successfully removed'));
    yield put(hideDeactivateStaffModal());
  } catch (error) {
    if (error.data && error.data.error && error.data.error.code === 2) {
      yield put(
        showDeactivateEmployeeErrorMessage(error.data.error.user_message)
      );
    } else {
      yield put(actNotif.error(error.message));
      yield put(hideDeactivateStaffModal());
    }
  } finally {
    yield put(hideProgressBar());
  }
}

export function* clickReactivateButtonFlow(request) {
  const { employee, availableSlots, user, formValues } = request.payload;
  const { data } = yield call(apiBilling.getBillings);
  const pendingBilling = _.find(data, ['status', 'pending']);

  yield put(setPendingBilling(pendingBilling));
  yield put(setAssignedEmployee(employee));

  if (
    (!employee.outlets && !formValues.outlets) ||
    (formValues.outlets && formValues.outlets.length === 0)
  ) {
    yield put(
      actNotif.error(
        'Please assign at least one outlet before you reactivate this employee'
      )
    );
  } else if (availableSlots.length > 0) {
    yield put(showReactivateStaffModal());
  } else if (!user.business.is_trial) {
    if (user.is_owner) {
      yield put(showReactivateStaffNoSlotModal());
    } else {
      yield put(
        actNotif.error(
          'Please contact your business owner to reactivate this employee'
        )
      );
    }
  } else {
    yield put(
      actNotif.error(
        'Unable to reactivate the employee. You have reached a limit of employees'
      )
    );
  }
}

export function* assignStaffToSlotFlow(request) {
  const {
    payload: { slot, employee, user, staffFormValues },
  } = request;
  try {
    if (staffFormValues) {
      // user may edit outlets before reactivate in inactive page
      yield call(apiEmployees.putEmployeesServiceV1, {
        data: staffFormValues,
        params: {},
        id: staffFormValues.id,
      });
    }
    const response = yield call(apiEmployees.putSlotEmployeeV1, {
      data: { assignedEmployeeId: employee.id },
      params: {},
      slotId: slot.id,
    });
    if (response.data) {
      yield put(
        actNotif.success(
          `${employee.first_name} ${employee.last_name} has been re-activated.`
        )
      );
      // to get updated empty slots and reset it
      const res = yield call(apiEmployees.getActiveEmployees, {
        params: { active: true, occupied: false },
      });
      if (res.data) {
        const sortedFreeSlots = sort(res.data, d =>
          d.status === 'Free' ? [`${d.outletId}`] : [`${d.createdAt}`]
        );
        const sortedSlots = sort(sortedFreeSlots, d => [
          `${d.status}`.toLowerCase(),
        ]);
        yield put(setAvailableSlots(sortedSlots));
      }
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(setAssignedEmployee(null));
    yield put(hideReactivateStaffModal());
    yield put(closeRightColumn());
  }
  yield put(
    listStaffRequest({ active: false, keyword: '', user, submitFlag: true })
  );
}

export function* clickPayReactivateFlow(request) {
  const { billingData, staffFormValues } = request.payload;
  if (staffFormValues) {
    yield call(apiEmployees.putEmployeesServiceV1, {
      data: staffFormValues,
      params: {},
      id: staffFormValues.id,
    });
  }
  yield put(verifyAddStaffSlot(billingData));
}

export function* stopRenewalFlow(request) {
  const {
    payload: { slot, previousSlots },
  } = request;
  try {
    const data = {
      assignedEmployeeId: slot.employee ? slot.employee.id : null,
      isRenewable: false,
    };
    const res = yield call(apiEmployees.putSlotEmployeeV1, {
      data,
      params: {},
      slotId: slot.id,
    });
    if (res.data) {
      const slotDetail = {
        ...res.data,
        employee: slot.employee,
      };
      yield put(setSlotDetail(slotDetail));

      const newSlots = [];
      previousSlots.forEach(prev => {
        if (prev.id === slot.id) {
          newSlots.push(slotDetail);
        } else {
          newSlots.push(prev);
        }
      });
      yield put(setEmployees({ employees: newSlots }));
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideStopRenewalModal());
  }
}

export function* clickLinkStopRenewal() {
  const { data } = yield call(apiBilling.getBillings);
  const pendingBilling = _.find(data, ['status', 'pending']);

  if (pendingBilling) {
    yield put(
      actNotif.error(
        'You can’t cancel this staff slot subscription due to a pending invoice payment.'
      )
    );
  } else {
    yield put(showStopRenewalModal());
  }
}

export default function* saga() {
  yield takeLatest(EMPLOYEE_STAFF_ON_CHANGE_KEYWORD, onChangeKeywordFlow);
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_EXPORT, onClickExportFlow);
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF,
    onClickInviteStaffFlow
  );
  yield takeLatest(EMPLOYEE_STAFF_LIST_STAFF_REQUEST, listStaffRequestFlow);
  yield takeLatest(EMPLOYEE_STAFF_LIST_ROLES_REQUEST, listRolesRequestFlow);
  yield takeLatest(EMPLOYEE_STAFF_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_CANCEL, onClickCancelFlow);
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_ROW, onClickRowFlow);
  yield takeLatest(EMPLOYEE_STAFF_LIST_OUTLET_REQUEST, listOutletRequestFlow);
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET,
    onClickAssignOutletFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET,
    onConfirmAssignOutletFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET,
    onCancelAssignOutletFlow
  );
  yield takeLatest(EMPLOYEE_STAFF_ON_SUBMIT_FORM, onSubmitFormFlow);
  yield takeLatest(EMPLOYEE_STAFF_RESEND_INVITATION, resendInvitationFlow);
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE,
    onCancelDeleteEmployeeFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE,
    onConfirmDeleteEmployeeFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE,
    onClickDeleteEmployeeFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION,
    onClickResendInvitationFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA,
    onClickResendWithValidCaptchaFlow
  );
  yield takeLatest(EMPLOYEE_STAFF_ON_CANCEL_RESEND, onCancelResendFlow);
  yield takeLatest(
    EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST,
    listPermissionRequestFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ACTIVE_STAFF_LIST_REQUEST,
    listActiveStaffRequestFlow
  );
  yield takeLatest(EMPLOYEE_STAFF_ON_CHANGE_STATUS, onChangeStatusFlow);
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_ADD_STAFF_SLOT, onClickAddSlotFlow);
  yield takeLatest(EMPLOYEE_STAFF_GET_FEATURE_PRICE, getStaffFeaturePriceFlow);
  yield takeLatest(EMPLOYEE_STAFF_VERIFY_ADD_STAFF_SLOT, verifyAddSlotsFlow);
  yield takeLatest(EMPLOYEE_STAFF_ON_DEACTIVATE_STAFF, deactivateStaffFlow);
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_REACTIVATE_BUTTON,
    clickReactivateButtonFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ASSIGN_EMPLOYEE_TO_SLOT,
    assignStaffToSlotFlow
  );
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_PAY_TO_REACTIVATE,
    clickPayReactivateFlow
  );
  yield takeLatest(EMPLOYEE_STAFF_STOP_RENEWAL_SLOT, stopRenewalFlow);
  yield takeLatest(
    EMPLOYEE_STAFF_ON_CLICK_LINK_STOP_RENEWAL,
    clickLinkStopRenewal
  );
  yield takeLatest(
    EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE,
    showDeactivateEmployeeErrorMessage
  );
}
